export function truncateLabel(value, maxLength = 32) {
    const text = String(value ?? "").trim();
    if (!text) return "";
    if (text.length <= maxLength) return text;
    if (maxLength <= 3) return ".".repeat(maxLength);
    return `${text.slice(0, maxLength - 3)}...`;
}
